/*
 * https://github.com/BuddyLReno/smarquee
 */
import Smarquee from './smarquee/_index-ie-polyfill';
// import Smarquee from 'smarquee';

(function () {

  if (!document.body.classList.contains('home')) return this;

  const target = document.getElementById('smarquee');
  let is_play = false;
  let smarquee = new Smarquee({
    selector: '#smarquee',
    element: null,
    velocity: 100,
    styleOptions: {
      scrollingTitleMargin: 24,
      delay: '2s',
      pausePercent: 10,
    },
    onAnimationStart() {
      is_play = true;
    },
    // onAnimationEnd() {},
    // onAnimationIterate() {},
    // onAnimationCancel() {},
    onClick() {
      if(is_play){
        is_play = false;
        smarquee.pause();
      }else{
        is_play = true;
        smarquee.play();
      }
    }
  });
  smarquee.init();

})();
